const BASE = "/api/party";

export async function getParties() {
  const res = await fetch(BASE);
  if (!res.ok) throw new Error("Failed to load parties");
  return res.json();
}
